import { useLanguage } from '@/hooks/useLanguage';
import { useLocation, useNavigate } from 'react-router-dom';
import { MdQrCode2 } from 'react-icons/md';
import './HeaderQrButton.css';

interface HeaderQrButtonProps {
  variant?: 'mobile' | 'desktop';
}

export function HeaderQrButton({ variant = 'mobile' }: HeaderQrButtonProps) {
  const navigate = useNavigate();
  const location = useLocation();
  const { t } = useLanguage();

  if (location.pathname === '/qr') {
    return null;
  }

  return (
    <button
      type="button"
      className={`header-qr-button header-qr-button--${variant}`}
      onClick={() => navigate('/qr')}
      aria-label={t('common.myQrCode')}
      title={t('common.myQrPill')}
    >
      <MdQrCode2 size={18} aria-hidden />
    </button>
  );
}
